<script setup>
import { ref, toRef } from "vue";
import forestreeHelpers from "@/helpers/forestreeHelpers";
import Avatar from "vue3-avatar";

const props = defineProps(["users", "assignTypeId", "permissions", "assignList", "teams"]);
const assignList = toRef(props.assignList);
const showAssignSelect = ref(false);
const msg = ref(null);
const selectTeam = ref(null);
const popOverRef = ref(null);

const close = () => {
    selectTeam.value = null;
};
const onChange = (uid, tid = null) => {
    msg.value = null;
    selectTeam.value = null;

    if (uid) {
        var findUser = props.users.assign_users.filter((u) => {
            return u.id === parseInt(uid);
        })[0];
    }

    if (tid) {
        var findUser = teams.value.filter((t) => {
            return t.id === parseInt(tid);
        })[0];
    }

    if (assignList.value.includes(findUser)) {
        msg.value = "Already assigned";
    } else {
        assignList.value.push(findUser);
        showAssignSelect.value = false;
    }
};
const unassign = (assign, idx) => {
    assignList.value.splice(idx, 1);
};
</script>
<template>
    <div class="td py-2 items-center text-slate-500">
        <div v-if="assignList" class="flex flex-wrap items-center">
            <span v-for="(assign, idx) in assignList" :key="idx">
                <popper placement="top" offset-distance="10">
                    <template #content>
                        <div class="py-3 px-2 bg-slate-50 shadow-md">
                            <p class="text-slate-600 text-center">
                                <span>{{ assign.name }}</span>
                                <button
                                    v-if="permissions.work_can_assign"
                                    @click="unassign(assign, idx)"
                                    class="ml-2 text-xs bg-slate-200 text-slate-700 hover:bg-red-600 hover:text-white py-1 px-2 rounded-full"
                                >
                                    Unassign
                                </button>
                            </p>
                        </div>
                    </template>

                    <avatar
                        :title="assign.name"
                        class="cursor-pointer -mr-1"
                        :name="assign.name.replace(/([0-9])/g, ' $1').trim()"
                        :background="forestreeHelpers.getAvatarColor(assign.name.replace(/([0-9])/g, ' $1').trim())"
                        color="#fff"
                        :size="32"
                        :customAvatarStyle="{
                            fontFamily: 'Arial',
                            fontSize: '12px',
                            'font-weight': 100,
                        }"
                    >
                    </avatar>
                </popper>
            </span>
            <span v-if="permissions && permissions.work_can_assign">
                <popper placement="bottom" offset-distance="0">
                    <template #content="{ close }">
                        <div class="popper">
                            <div class="">
                                <div
                                    v-if="teams && teams.length"
                                    class="bg-slate-200 text-slate-700 font-medium text-xs p-2"
                                >
                                    External
                                </div>
                                <div v-if="teams && teams.length" class="py-2 max-h-64 overflow-y-auto">
                                    <div
                                        v-for="team in teams"
                                        :key="team.id"
                                        @click="selectTeam = team.id"
                                        class="p-2 text-slate-600 hover:bg-blue-600 hover:text-white cursor-pointer"
                                    >
                                        {{ team.name }}
                                        <div v-if="selectTeam === team.id" class="pt-2 text-xs">
                                            Send this job to <b>{{ team.name }}</b
                                            >?
                                        </div>
                                        <div v-if="selectTeam === team.id" class="text-right pt-2">
                                            <button
                                                @click="
                                                    onChange(null, team.id);
                                                    close();
                                                "
                                                type="button"
                                                class="inline-flex items-center rounded border border-slate-300 bg-white px-2 py-1 text-xs font-medium text-slate-700 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                            >
                                                Yes
                                            </button>
                                            <button
                                                @click="close()"
                                                type="button"
                                                class="inline-flex items-center rounded border border-slate-300 bg-white px-2 py-1 text-xs font-medium text-slate-700 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                            >
                                                No
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="">
                                <div class="bg-slate-200 text-slate-700 font-medium text-xs p-2">Users</div>
                                <div class="py-2 max-h-64 overflow-y-auto">
                                    <p
                                        v-for="user in props.users.assign_users"
                                        :key="user.id"
                                        @click="
                                            onChange(user.id, null);
                                            close();
                                        "
                                        class="p-2 text-slate-600 hover:bg-blue-600 hover:text-white cursor-pointer"
                                    >
                                        {{ user.name }}{{ user.company_name ? " (" + user.company_name + ")" : "" }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </template>
                    <avatar
                        class="cursor-pointer hover:bg-grey-300"
                        name="+"
                        background="#eee"
                        :size="32"
                        color="#bbb"
                        :customStyle="{ 'font-size': '30px' }"
                    >
                    </avatar>
                </popper>
            </span>
        </div>
        <div v-else class="flex flex-wrap items-center">
            <span @click="showAssignSelect = !showAssignSelect" v-if="permissions && permissions.work_can_assign">
                <avatar
                    class="cursor-pointer hover:bg-grey-300"
                    name="+"
                    background="#eee"
                    :size="32"
                    color="#bbb"
                    :customStyle="{ 'font-size': '30px' }"
                >
                </avatar>
            </span>
        </div>
        <div v-if="msg" class="px-2 pt-2">
            <p class="text-xs text-red-400">{{ msg }}</p>
        </div>
    </div>
</template>
<style>
.popper {
    min-width: 250px;
    max-width: 350px;
    text-align: left;
    padding: 0px;
    font-size: 15px;
    box-shadow: rgb(58 58 58 / 50%) 3px 3px 10px 1px;
}

.max-h-64 {
    max-height: 15rem;
}
</style>
